import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initDeployUpdateGuard, initStaleAssetRecovery } from './utils/deployUpdateGuard';

import { initPwaInstallCapture } from './utils/pwaInstallCapture';

initPwaInstallCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

initStaleAssetRecovery();
initDeployUpdateGuard();

// Enable service worker for offline support (production builds only)
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
